import Query, { type FilterItem } from '@incident-center/mongolike-query';

import { type IndexRequestSchema } from '@api/services/merchants';

import {
  type RequestForm,
  type RequestFormFilterKeys,
  type RequestFormFilters,
  type RequestFormSortKey,
} from '../model';

const getFilterValue = <K extends RequestFormFilterKeys>(
  filters: RequestFormFilters,
  key: K,
): RequestFormFilters[K] => {
  return filters[key];
};

const mapFilterValues = (
  filters: RequestFormFilters,
): FilterItem<RequestFormFilterKeys>[] => {
  const res: FilterItem<RequestFormFilterKeys>[] = [];
  const filtersKeys = Object.keys(filters) as RequestFormFilterKeys[];

  filtersKeys.forEach((item) => {
    switch (item) {
      case 'value': {
        const value = getFilterValue(filters, item);
        if (value) {
          res.push({
            key: item,
            operator: 'ilike',
            value,
          });
        }
        break;
      }
      default: {
        const value = getFilterValue(filters, item);
        if (value !== undefined) {
          res.push({
            key: item,
            operator: '=',
            value,
          });
        }
        break;
      }
    }
  });

  return res.filter((i) => i.value !== '');
};

const makeRequestSchema = (
  requestFormValues: RequestForm,
): IndexRequestSchema => {
  const query = new Query<RequestFormFilters, RequestFormSortKey>();

  if (requestFormValues.filter) {
    const mappedFilterValues = mapFilterValues(requestFormValues.filter);
    mappedFilterValues.forEach((item) => {
      query.filter(item.key, item.operator, item.value as string | number);
    });
  }

  if (requestFormValues.sort) {
    query.sort(requestFormValues.sort.key, requestFormValues.sort.order);
  }

  query.limit(requestFormValues.limit).offset(requestFormValues.offset);

  return query.get();
};

export default makeRequestSchema;
